<template lang="pug">
div
  screen-title(title="online_booking.advanced_settings_heading")
  .box
    label.label {{$t('online_booking.booking_intervals_label')}}
    b-field
      b-radio(v-model="interval" name="interval" :native-value="ONLINE_BOOKING_INTERVALS.DEFAULT") 
        span {{ $t('online_booking.intervals_default') }} 
        p.help {{ $t('online_booking.intervals_default_help') }}
    b-field
      b-radio(v-model="interval" name="interval" :native-value="ONLINE_BOOKING_INTERVALS.SLOTS") 
        span {{ $t('online_booking.intervals_slots') }}
        p.help {{ $t('online_booking.intervals_slots_help') }}
     
  .buttons.mt-4
    action-button(title="actions.save" @click="submit" :loading="submitting" permission="ONLINE_BOOKING_SETTINGS_MANAGE" scope)
</template>

<script>
import {mapState} from 'vuex'
import ONLINE_BOOKING_INTERVALS from '../../../constants/onlineBookingIntervals'

export default {
  name: 'OnlineBookingSettingsAdvanced',
  data() {
    return {
      ONLINE_BOOKING_INTERVALS,
      submitting: false,
      interval: ONLINE_BOOKING_INTERVALS.DEFAULT
    }
  },
  computed: {
    ...mapState('company', ['company'])
  },
  created() {
    this.interval = this.company.onlineBookingInterval || ONLINE_BOOKING_INTERVALS.DEFAULT
  },
  methods: {
    async submit() {
      if (this.submitting) return
      this.submitting = true
      const valid = await this.$validator.validateAll()
      if (!valid) {
        this.submitting = false
        return
      }

      const data = {
        onlineBookingInterval: this.interval
      }
      try {
        await this.$store.dispatch('company/update', data)
        this.$buefy.toast.open({message: this.$t('status.save_success'), type: 'is-success', queue: false})
        this.$emit('saved')
      } catch (error) {
        this.$handleAPIError(error)
      }
      this.submitting = false
    }
  }
}
</script>
